import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url, postHeader } from "../Helpers/request";
import { useHistory } from "react-router-dom";
import Loader from "./Loader";
import { Col, Modal, Row } from "react-bootstrap";
import swal from "sweetalert";
import { useDispatch } from "react-redux";
import { cartlengthvalue } from "../Reducer/cartReducer";
import { whishlistlength } from "../Reducer/wishlistReducer";
import { sessionId } from "../Reducer/homeReducer";

export default function CardNox(props) {

  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState([]);
  const onChangeHandle = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.name === 'card_name' ? e.target.value : !isNaN(+e.target.value) ? e.target.value : "" });
  };


  const handlelogout = () => {
    localStorage.removeItem('bw-user');
    dispatch(whishlistlength(0))
    dispatch(cartlengthvalue(0))
    dispatch(sessionId(''))
    history.push("/")
    window.location.reload(true);
  }

  const submit = () => {
    setLoader(true);
    let payload = {
      card_number: inputData.card_number,
      card_exp_month: inputData.card_exp_month,
      card_exp_year: inputData.card_exp_year,
      card_cvc: inputData.card_cvc,
      card_name: inputData.card_name,
      order_id: props?.data?.order_id,
    };
    axios.post(base_url + "/order/payment", payload, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setLoader(false);
          dispatch(cartlengthvalue(0));
          sessionStorage.removeItem("bw-checkoutdata");
          history.push(
            `/ordersuccess/${response.data.data.order_id}/${response.data.data.order_no}/${response.data.data.txn_id}`
          );
        }
        if (response.data.status == 2) {
          setLoader(false);
          handlelogout();
        } else {
          setLoader(false);
          return swal(response.data.message[0]?.category, "", "error");
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  useEffect(() => { }, []);

  let CurrentYear = new Date().getFullYear();
  let currentYearString = CurrentYear.toString();
  currentYearString = currentYearString.substring(2);


  return (
    <>
      <Modal
        show={open}
        onHide={() => {
          setOpen(false);
          props.popupclose();
        }}
        centered
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header> */}
        <Modal.Body className="mb-5">

          <h2 className="mb-4 text-center">Enter Card Details</h2>
          <Row>
            <Col lg={12}>
              <div className="mb-4">
                <input
                  type="text"
                  className="form-control"
                  name="card_name"
                  placeholder="Card Name"
                  value={inputData.card_name}
                  onChange={(e) => onChangeHandle(e)}
                />
              </div>

            </Col>
            <Col lg={12}>
              <div className="mb-4">
                <input
                  type="text"
                  className="form-control"
                  name="card_number"
                  placeholder="Card Number"
                  value={inputData.card_number}
                  onChange={(e) => onChangeHandle(e)}
                />
              </div>
            </Col>
            <Col lg={4}>
              <div className="mb-4">

                <select className="form-control" name="card_exp_month" onChange={(e) => onChangeHandle(e)}>
                  <option value="" disabled selected>Month</option>
                  {
                    Array(13).fill().map((month, ind) => {
                      if (ind !== 0) {
                        return <option key={ind} value={ind}>{ind}</option>
                      }
                    }

                    )
                  }
                </select>
              </div>
            </Col>
            <Col lg={4}>
              <div className="mb-4">
                <select className="form-control" name="card_exp_year" onChange={(e) => onChangeHandle(e)}>
                  <option value="" disabled selected>Year</option>
                  {
                    Array(50).fill().map((year, ind) => {
                      return <option key={ind} value={Number(currentYearString) + ind}>{(CurrentYear + ind)}</option>
                    }
                    )
                  }
                </select>
              </div>
            </Col>
            <Col lg={4}>
              <div className="mb-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="CVV"
                  name="card_cvc"
                  value={inputData.card_cvc}
                  onChange={(e) => onChangeHandle(e)}
                />
              </div>
            </Col>

            <Col lg={12}>
              <button className="btn btn-dark bw_sbtn btn-lg" onClick={() => submit()}>
                Pay
              </button>
            </Col>
          </Row>
        </Modal.Body>

      </Modal>
      <Modal show={loader} >
          <Loader />
        </Modal>
    </>
  );
}
